import get from 'lodash/get'
import { LiquidationAsset } from './types'
import isEmpty from 'lodash/isEmpty'
import { CustomToken } from './types'

export const buildAssetSections = (customData: Record<string, unknown>) => {
  const networkChainIds = Object.keys(customData)
  const sections: { title: string; data: LiquidationAsset[] }[] = []

  networkChainIds.forEach((chainId) => {
    const tokens: LiquidationAsset[] = []

    const tokenKeysByNetwork = Object.keys(
      customData[chainId] as Record<string, unknown>,
    )
    tokenKeysByNetwork.forEach((tokenKey) => {
      const token = get(customData[chainId], tokenKey, {}) as LiquidationAsset
      if (!isEmpty(token) && token.isSelected) {
        tokens.push(token)
      }
    })
    if (tokens.length > 0) {
      sections.push({
        title: get(customData, `${chainId}.name`, '') as string,
        data: tokens,
      })
    }
  })

  return sections
}

export const onGetTokensFromCustomLiquidation = (
  customData: Record<string, unknown>,
) => {
  const networkChainIds = Object.keys(customData)
  const tokens: LiquidationAsset[] = []
  networkChainIds.forEach((chainId) => {
    const tokenKeysByNetwork = Object.keys(
      customData[chainId] as Record<string, unknown>,
    )
    tokenKeysByNetwork.forEach((tokenKey) => {
      const token = get(customData[chainId], tokenKey, {}) as LiquidationAsset
      if (!isEmpty(token) && token.isSelected) {
        tokens.push(token)
      }
    })
  })

  return tokens
}

export const checkVerifiedToken = (token: CustomToken) => {
  // This function would need to be adapted based on your token verification logic
  // For now, returning true as a placeholder
  return true
}
